// extracted by mini-css-extract-plugin
module.exports = {"end-spreader":"end-spreader___26kRf","endSpreader":"end-spreader___26kRf","cross":"cross___36DXF"};